import React, { useState, useEffect } from 'react';
import './ImpactPage.css';
import { BarChart, Users, Star, Globe, TrendingDown, Leaf, Recycle, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

function ImpactPage() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="impact-page-wrapper">
      {/* Hero Section */}
      <section className="impact-hero">
        <div className="impact-bg-glow"></div>
        <div className="impact-container text-center relative z-10">
          <div className={`fade-in-up ${isVisible ? 'active' : ''}`}>
            <span className="impact-badge">
              <Leaf size={16} color="#10B981" /> Notre grand engagement
            </span>
            <h1 className="impact-title">
              Réduire le gaspillage,<br />
              <span className="text-gradient-green">un flux à la fois.</span>
            </h1>
            <p className="impact-subtitle text-muted">
              En lissant les pics d'affluence dans les restaurants universitaires,<br />
              CrousRadar participe activement à la réduction du gaspillage alimentaire.
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="impact-stats">
        <div className="impact-container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon bg-blue-light">
                <BarChart size={32} color="#3B82F6" />
              </div>
              <div className="stat-number">200+</div>
              <div className="stat-label">Restaurants Crous</div>
              <p className="stat-description">Une couverture nationale pour maximiser l'impact étudiant.</p>
            </div>

            <div className="stat-card">
              <div className="stat-icon bg-orange-light">
                <Users size={32} color="var(--primary)" />
              </div>
              <div className="stat-number">700K+</div>
              <div className="stat-label">Étudiants touchés</div>
              <p className="stat-description">Une immense audience mobilisée pour réguler les flux.</p>
            </div>

            <div className="stat-card">
              <div className="stat-icon bg-green-light">
                <Heart size={32} color="#10B981" />
              </div>
              <div className="stat-number">100%</div>
              <div className="stat-label">Gratuit & Solidaire</div>
              <p className="stat-description">Un outil au service du bien commun et des étudiants.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="impact-how bg-light">
        <div className="impact-container">
          <div className="how-header text-center">
            <h2 className="section-title">Comment ça fonctionne ?</h2>
            <p className="section-description">Un cercle vertueux pour l'écologie et l'efficacité.</p>
          </div>
          
          <div className="how-grid">
            <div className="how-step">
              <div className="step-number">01</div>
              <h3>Régulation des flux</h3>
              <p>En informant les étudiants de l'affluence en temps réel, CrousRadar permet d'étaler la fréquentation et d'éviter les files d'attente interminables.</p>
            </div>

            <div className="how-step">
              <div className="step-number">02</div>
              <h3>Données prédictives</h3>
              <p>Les restaurants CROUS peuvent s'appuyer sur nos données d'affluence pour mieux anticiper et ajuster la production de repas.</p>
            </div>

            <div className="how-step">
              <div className="step-number">03</div>
              <h3>Moins de gaspillage</h3>
              <p>Grâce à une meilleure répartition des repas servis, nous limitons la surproduction et, in fine, le gaspillage alimentaire.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact visuel */}
      <section className="impact-visual">
        <div className="impact-container">
          <div className="visual-grid">
            <div className="visual-content">
              <h2 className="section-title">Un potentiel d'impact positif</h2>
              <p className="text-muted text-lg mb-6">
                Chaque jour, CrousRadar aide des milliers d'étudiants à optimiser leur temps. Cette régulation organique ouvre la voie à une gestion plus durable.
              </p>
              
              <div className="visual-facts">
                <div className="fact">
                  <span className="fact-icon"><Recycle size={24} color="#10B981" /></span>
                  <span className="fact-text">Contribue à la réduction du gaspillage</span>
                </div>
                <div className="fact">
                  <span className="fact-icon"><TrendingDown size={24} color="var(--primary)" /></span>
                  <span className="fact-text">Diminue les temps d'attente moyens de 30%</span>
                </div>
                <div className="fact">
                  <span className="fact-icon"><Globe size={24} color="#3B82F6" /></span>
                  <span className="fact-text">Vision durable de la restauration</span>
                </div>
              </div>
            </div>

            <div className="visual-image-wrapper">
              <img src="/smiling_students_1774986317414.png" alt="Étudiants" className="visual-photo" />
              <div className="overlay-gradient"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Engagement */}
      <section className="impact-commitment">
        <div className="impact-container">
          <div className="commitment-box">
            <p>
              Rejoins les milliers d'étudiants qui utilisent déjà CrousRadar pour optimiser leur pause déj' et réduire le gaspillage.
            </p>
            <div className="flex-center mt-8">
              <Link to="/" className="btn-primary large">
                Découvrir l'App
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ImpactPage;